<template lang="pug">
  v-text-field.mr-2(
    clearable,
    hide-details,
    prepend-icon="fas fa-search",
    :label="label",
    :value="search",
    @input="debounceSearch",
    @click:clear="$emit('update:search', null)",
  )
</template>

<script>
export default {
  props: {
    clearable: {
      type: Boolean,
      default: false,
    },

    label: {
      type: String,
      requried: true,
    },

    search: {
      validator: prop => ['string', 'object'].includes(typeof prop),
      required: true,
    },
  },

  data() {
    return {
      search_timeout: null,
    };
  },

  methods: {
    debounceSearch(payload) {
      if (this.search_timeout) {
        clearTimeout(this.search_timeout);
      }

      this.search_timeout = setTimeout(() => {
        this.$emit('update:search', payload);
      }, 500);
    },
  },
};
</script>
